export const AUTH_ENDPOINTS = {
  CONVERT: `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/auth/jek`,
  REFRESH: `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/auth/refresh-token`,
  ME: `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/user/me`,
  B2B_PROFILE: `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/b2b/profile`,
  UPDATE_ME: `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/user/me`,
  LOGIN: `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/auth/password`
};

export const REFRESH_BUFFER_MS = 10 * 60 * 1000;

export const TOKEN_STORAGE_KEY = "st_token";
export const REFRESH_TOKEN_STORAGE_KEY = "st_refresh_token";

export const LEGACY_ACCESS_TOKEN_KEY = "access-token";
export const LEGACY_REFRESH_TOKEN_KEY = "refresh-token";
